import { useI18n } from "../lib/i18n";
import { ShieldCheck } from "lucide-react";

// Small, brand-recognizable payment-method marks used purely as a trust signal
// under the pricing cards. Icons are inline SVGs so no external requests.
const METHODS = [
  {
    name: "Visa",
    svg: (
      <svg viewBox="0 0 780 500" className="h-4 w-auto" aria-label="Visa">
        <path fill="#fff" d="M293.2 348.7L318.7 148h40.9l-25.5 200.7h-40.9zM528.7 152.2c-8.1-3.2-20.9-6.7-36.8-6.7-40.6 0-69.3 21.6-69.5 52.5-.3 22.9 20.4 35.7 36 43.3 16 7.8 21.4 12.8 21.3 19.7-.1 10.6-12.8 15.4-24.7 15.4-16.5 0-25.3-2.4-38.9-8.3l-5.3-2.5-5.8 35.4c9.7 4.4 27.5 8.2 46.1 8.4 43.2 0 71.4-21.3 71.7-54.3.2-18.1-11-31.9-35-43.3-14.6-7.4-23.5-12.3-23.4-19.8 0-6.6 7.7-13.7 24.3-13.7 13.8-.2 23.9 2.9 31.7 6.1l3.8 1.8 5.5-34zM634.2 148h-31.6c-9.8 0-17.1 2.8-21.4 12.9l-60.8 145.8-1.4 3.1c14.4 0 26.6-6.1 32.5-14l17.4-46.9h51.6l9.5 60.9h38.2L634.2 148zm-46.5 129.9c3.4-8.9 16.3-42.7 16.3-42.7-.2.4 3.4-9 5.5-14.8l2.8 13.4s7.8 36.4 9.4 44.1h-34zM249.3 148l-40.1 136.9-4.3-21.4c-7.5-24.6-30.6-51.3-56.5-64.6l36.6 149.7 43.6-.1L293.2 148h-43.9z"/>
        <path fill="#F79E1B" d="M172 148h-66.7l-1 4.9c51.9 12.9 86.2 44.5 100.3 82.5L189.8 161c-2.5-9.8-9.6-12.7-18.4-13"/>
      </svg>
    ),
  },
  {
    name: "Mastercard",
    svg: (
      <svg viewBox="0 0 152 100" className="h-4 w-auto" aria-label="Mastercard">
        <circle cx="60" cy="50" r="40" fill="#EB001B"/>
        <circle cx="92" cy="50" r="40" fill="#F79E1B"/>
        <path fill="#FF5F00" d="M76 20a40 40 0 010 60 40 40 0 010-60z"/>
      </svg>
    ),
  },
  {
    name: "American Express",
    svg: (
      <svg viewBox="0 0 780 500" className="h-4 w-auto" aria-label="American Express">
        <rect width="780" height="500" rx="40" fill="#016FD0"/>
        <path fill="#fff" d="M172 259l14-36 14 36h-28zm480-19h-42v-18h42v-16h-42v-17h42v-16h-60v83h60v-16zm-142 0h-44v-18h44v-16h-44v-17h44v-16h-62v83h62v-16zm-77 16h-19l-24-33-24 33h-22l35-45-33-38h21l22 31 22-31h20l-33 38 35 45zm-140-83h-19l-24 62-24-62h-32v78l-33-78h-24l-36 83h20l7-19h37l7 19h37v-63l27 63h16l27-63v63h20v-83zm322-1c-24 0-40 15-40 40 0 26 16 43 40 43 20 0 33-11 37-29h-19c-2 8-9 13-18 13-13 0-21-9-21-27 0-16 8-25 21-25 9 0 15 5 17 12h20c-4-17-17-27-37-27z"/>
      </svg>
    ),
  },
  {
    name: "Apple Pay",
    svg: (
      <svg viewBox="0 0 165 100" className="h-4 w-auto" aria-label="Apple Pay">
        <rect width="165" height="100" rx="14" fill="#000"/>
        <path fill="#fff" d="M40 35c-1 3-3 5-6 5 0-3 1-5 3-6 2-1 4-2 5-2 0 1 0 2-2 3zm2 3c-3 0-5 2-6 2s-3-2-6-2c-3 0-6 2-7 4-3 6-1 15 2 20 2 3 3 6 6 6s3-2 6-2 4 2 7 2 4-2 6-6c1-2 2-4 3-6-6-3-6-11-1-14-2-3-6-4-10-4zm35 3h-8v20h4v-7h4c4 0 7-3 7-7 0-4-3-6-7-6zm-1 10h-3v-7h3c2 0 4 1 4 3 0 3-2 4-4 4zm22-3c-3 0-5 1-7 2l1 3c1-1 3-2 5-2 3 0 4 2 4 4v1c-1 0-2-1-5-1-4 0-7 2-7 5s3 5 6 5c2 0 4-1 5-3v2h3v-9c0-5-3-7-5-7zm-4 15c-2 0-4-1-4-3s3-2 5-2c1 0 2 0 3 1v1c0 2-2 3-4 3zm22-14l-4 12-4-12h-4l6 15-1 4c-1 2-1 3-3 3v3s1 1 3 1c3 0 4-1 6-6l8-20h-4z"/>
      </svg>
    ),
  },
  {
    name: "Google Pay",
    svg: (
      <svg viewBox="0 0 165 100" className="h-4 w-auto" aria-label="Google Pay">
        <rect width="165" height="100" rx="14" fill="#fff"/>
        <text x="82" y="60" textAnchor="middle" fontSize="26" fontWeight="700" fill="#5f6368" fontFamily="Arial, sans-serif">
          <tspan fill="#4285F4">G</tspan><tspan fill="#EA4335">o</tspan><tspan fill="#FBBC05">o</tspan><tspan fill="#4285F4">g</tspan><tspan fill="#34A853">l</tspan><tspan fill="#EA4335">e</tspan><tspan fill="#5f6368"> Pay</tspan>
        </text>
      </svg>
    ),
  },
  {
    name: "PayPal",
    svg: (
      <svg viewBox="0 0 80 24" className="h-4 w-auto" aria-label="PayPal">
        <text x="4" y="17" fontSize="15" fontWeight="800" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="-0.5">
          <tspan fill="#003087">Pay</tspan><tspan fill="#009cde">Pal</tspan>
        </text>
      </svg>
    ),
  },
  {
    name: "SEPA",
    svg: (
      <svg viewBox="0 0 60 24" className="h-4 w-auto" aria-label="SEPA">
        <rect width="60" height="24" rx="4" fill="#10298E"/>
        <text x="30" y="16" textAnchor="middle" fontSize="10" fontWeight="700" fill="#FFCC00" fontFamily="Arial, sans-serif">SEPA</text>
      </svg>
    ),
  },
];

export default function PaymentIcons() {
  const { lang } = useI18n();
  const secureLabel = {
    en: "Secure payment · Cancel anytime · No hidden fees",
    it: "Pagamento sicuro · Cancella quando vuoi · Nessun costo nascosto",
    es: "Pago seguro · Cancela cuando quieras · Sin costes ocultos",
    fr: "Paiement sécurisé · Annulez à tout moment · Sans frais cachés",
    de: "Sichere Zahlung · Jederzeit kündbar · Keine versteckten Gebühren",
  };
  return (
    <div className="mt-12 flex flex-col items-center gap-4" data-testid="payment-icons-strip">
      <div className="flex items-center gap-2 text-sm text-zinc-400">
        <ShieldCheck className="w-4 h-4 text-emerald-400" />
        <span>{secureLabel[lang] || secureLabel.en}</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 opacity-90">
        {METHODS.map((m) => (
          <div
            key={m.name}
            data-testid={`pay-method-${m.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
            className="rounded-md border border-white/10 bg-white/[0.03] px-3 py-2 flex items-center justify-center hover:border-white/20 transition-colors"
            title={m.name}
          >
            {m.svg}
          </div>
        ))}
      </div>
    </div>
  );
}
